import { HttpParams } from '@angular/common/http'
import { Injectable } from '@angular/core'
import { StaffReportTypeEnum } from '@galabid/gb-dashboard/staff/data-access'
import { GbApiService } from 'libs/shared/data-access-core/src/lib/+state/gb-api.service'
import { Observable } from 'rxjs'

@Injectable({
  providedIn: 'root',
})
export class StaffApiService extends GbApiService {
  exportStaffReport(staffReportType: StaffReportTypeEnum, startDate: string, endDate: string): Observable<void> {
    const url = `${staffReportType}/`
    const params = new HttpParams().set('start_date', startDate).set('end_date', endDate)
    return this.get<void>(url, { params })
  }

  exportVoucherReport(startDate: string, endDate: string) {
    const encodedStartDate = encodeURIComponent(startDate)
    const encodedEndDate = encodeURIComponent(endDate)
    const url = `${StaffReportTypeEnum.Vouchers}/?start_date=${encodedStartDate}&end_date=${encodedEndDate}`
    return this.download(url)
  }

  createInvalidation(): Observable<void> {
    const url = `cloudfront-invalidations/`
    return this.get(url)
  }
}
